module.exports = "<input type=\"{{type}}\" id=\"textFieldId\" placeholder=\"{{placeHolderText}}\">"